import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { SystemButton } from '@ipfabric/ui-components/SystemButton/SystemButton';
import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { FC } from 'react';
import { type StepIndex, isStepIndex } from './configWizard.types';
import { wizardStepsConfig } from './wizardConfig';

interface WizardStepperProps {
  selectedStep: number;
  onSelect: (step: StepIndex) => void;
  isSubmitting?: boolean;
  disabled?: boolean;
}

export const WizardStepper: FC<WizardStepperProps> = (props) => {
  return (
    <div className='flex'>
      {wizardStepsConfig.map((step, idx) => (
        <div className='flex items-center' key={step.icon}>
          <Tooltip content={step.tooltip} placement='bottom'>
            <SystemButton
              dataTestId={`wizard-stepper-step-${idx + 1}`}
              icon={step.icon}
              iconProps={{
                iconStyle: props.selectedStep === idx ? 'regular' : 'solid',
                className: props.isSubmitting
                  ? 'text-status-disabled-dark'
                  : '',
              }}
              size='large'
              // Increase specificity to override IconButton padding and color.
              // It is a little hacky but other solutions are more complicated
              // and this is exceptional case because of unique stepper design
              disabled={props.isSubmitting || props.disabled}
              onClick={() => {
                if (isStepIndex(idx)) {
                  props.onSelect(idx);
                } else {
                  stumble('WizardStepper: step index is not valid');
                }
              }}
            />
          </Tooltip>
          {idx < wizardStepsConfig.length - 1 && (
            <div className='h-[2px] w-[10px] bg-status-disabled-dark' />
          )}
        </div>
      ))}
    </div>
  );
};
